import { render, staticRenderFns } from "./planDet.vue?vue&type=template&id=056c015f&scoped=true&"
import script from "./planDet.vue?vue&type=script&lang=js&"
export * from "./planDet.vue?vue&type=script&lang=js&"
import style0 from "./planDet.vue?vue&type=style&index=0&id=056c015f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056c015f",
  null
  
)

export default component.exports